import Box from '@mui/material/Box';
import { SectionTitle, Subsection } from '../components/SectionPrimitives';

export function Section10(): JSX.Element {
  return (
    <Box>
      <SectionTitle>10. Entire Agreement</SectionTitle>

      <Subsection title="10.1 Severability">
        The Agreement constitutes the entire agreement between the parties
        regarding the subject matter and supersedes all prior negotiations,
        understandings, and agreements, whether written or oral. If any
        provision of the Agreement is found to be invalid or unenforceable, such
        provision shall be modified to the minimum extent necessary to make it
        valid and enforceable whilst preserving the economic effect of the
        original provision. All other provisions shall remain in full force and
        effect.
      </Subsection>

      <Subsection title="10.2 Waiver">
        No failure or delay in exercising any right or remedy under the
        Agreement shall constitute a waiver of that right or remedy. A waiver
        shall only be valid if made in writing by the party against whom it is
        sought to be enforced.
      </Subsection>

      <Subsection title="10.3 No Third-Party Beneficiaries">
        The Agreement is intended solely for the benefit of the parties and
        their respective successors and permitted assigns. No third party has
        any rights under the Agreement.
      </Subsection>

      <Subsection title="10.4 Amendment">
        UKVG reserves the right to amend the Terms from time to time. Material
        amendments shall be notified to Partners at least 30 days in advance.
        Continued use of the platform after the amendment period shall
        constitute acceptance. Partners may cancel if they do not accept the
        changes.
      </Subsection>
    </Box>
  );
}
